export const DEFAULT_RISK_OUTLOOK_FILTERS = {
  showRiskOutlookWatchlist: true,
  showRiskSmoke: true,
  showRiskFire: true,
}

export const getDefaultMarketContextToggleObj = () => ({
  showRiskEvents: false,
  showUnrecognisedRiskStatus: true,
  showNoteHistory: false,
  ...DEFAULT_RISK_OUTLOOK_FILTERS,
})
